import { Pressable } from 'react-native'
import { ContentContainerProps, FilePreviewProps } from './types'
import styled from 'styled-components/native'
import Icon from 'APP/Converse/Icon'

export const Container = styled.View<ContentContainerProps>`
  width: ${({ size }) => `${size?.width}px`};
  ${({ theme }) => theme.shadows.soft};
  background-color: ${({ theme }) => theme.colors.elementsBg};
  border-radius: ${({ theme }) => theme.metrics.borderRadius.small}px;
  border: 1px solid ${({ theme }) => theme.colors.elementsBorder};
  align-self: flex-start;
  overflow: hidden;
`

export const TextContainer = styled.View`
  padding: ${({ theme }) => theme.metrics.baseMargin / 4}px;
`

export const DeleteButton = styled(Pressable)`
  position: absolute;
  top: ${({ theme }) => theme.metrics.baseMargin / 2}px;
  right: ${({ theme }) => theme.metrics.baseMargin / 2}px;
  background-color: ${({ theme }) => theme.colors.elementsBg};
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: 1px solid ${({ theme }) => theme.colors.elementsBorder};
  ${({ theme }) => theme.shadows.soft};
`

export const StyledImage = styled.Image<Pick<FilePreviewProps, 'aspectRatio'>>`
  width: 100%;
  aspect-ratio: ${({ aspectRatio }) => aspectRatio};
  resize-mode: cover;
`

export const PlaceholderView = styled.View<Pick<FilePreviewProps, 'aspectRatio'>>`
  width: 100%;
  aspect-ratio: ${({ aspectRatio }) => aspectRatio};
  background-color: ${({ theme }) => theme.colors.elementsBg};
  border-radius: ${({ theme }) => theme.metrics.borderRadius.small / 4}px;
  align-items: center;
  justify-content: center;
`

export const PDFIcon = styled.Image`
  width: 40px;
  height: 40px;
`

export const DeleteIcon = styled(Icon)`
  color: ${({ theme }) => theme.colors.dim};
`
